export const AREAS = {
  annotations: 'annotations',
  leftAxis: 'left-axis',
  leftThreshold: 'left-threshold',
  bottomAxis: 'bottom-axis',
  rightAxis: 'right-axis',
  rightThreshold: 'right-threshold',
};
